import React from 'react'

const CalenderIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 1.5V3.75" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 1.5V3.75" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.625 6.82031H15.375" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5 14.25C16.5 14.8125 16.3425 15.345 16.065 15.795C15.5475 16.665 14.595 17.25 13.5 17.25C12.7425 17.25 12.0525 16.9725 11.5275 16.5C11.295 16.305 11.0925 16.065 10.935 15.795C10.6575 15.345 10.5 14.8125 10.5 14.25C10.5 12.5925 11.8425 11.25 13.5 11.25C14.4 11.25 15.2025 11.6475 15.75 12.27C16.215 12.8025 16.5 13.4925 16.5 14.25Z" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.3301 14.2506L13.0726 14.9931L14.6701 13.5156" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.25 9.825V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375V12.27C15.2025 11.6475 14.4 11.25 13.5 11.25C11.8425 11.25 10.5 12.5925 10.5 14.25C10.5 14.8125 10.6575 15.345 10.935 15.795C11.0925 16.065 11.295 16.305 11.5275 16.5H6C3.375 16.5 2.25 15 2.25 12.75" stroke="#1E293B" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.99661 10.2734H9.00335" stroke="#1E293B" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.22073 10.2734H6.22747" stroke="#1E293B" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.22073 12.5234H6.22747" stroke="#1E293B" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    )
}

export default CalenderIcon






